import {ReactNode} from 'react';

import styled, {css} from 'styled-components';

import {BannerType, BannerTypes} from 'shared/components/MessageBanner/Themes';
import {Breakpoints, Spacing} from 'styles/Base';

interface Props {
  type: BannerType;
  children?: ReactNode;
}

export default styled(({children, type, ...rest}: Props) => <div {...rest}>{children}</div>)`
  flex-shrink: 0;

  * {
    ${({type}) => css`
      border-color: ${BannerTypes[type].styles.border};
      color: ${BannerTypes[type].styles.text};
      width: 100%;

      &:hover {
        background-color: ${BannerTypes[type].styles.background};
      }
    `};
  }

  ${`@media (${Breakpoints.MOBILE})`} {
    margin-top: ${Spacing.ONE};
    width: 100%;
  }
`;
